<template>
  <!-- <div class="fit column bg-secondary overflow-hidden"> -->
  <Layout>
    <template #header> 车辆状态融合感知 </template>
    <template #default>
      <q-card bordered class="column full-height">
        <q-card-section class="row overflow-hidden" style="flex: 1">
          <div class="absolute FL text-h6 text-weight-bold">FL</div>
          <div class="absolute FR text-h6 text-weight-bold">FR</div>
          <div class="absolute RL text-h6 text-weight-bold">RL</div>
          <div class="absolute RR text-h6 text-weight-bold">RR</div>
          <div></div>
          <!-- left -->
          <div class="col-3 full-height column q-pr-md">
            <div class="col-6 row justify-center items-center">
              <FrictionCircleChart :notifyData="notifyData" name="左前" />
            </div>
            <div class="col-6 row justify-center items-center">
              <FrictionCircleChart :notifyData="notifyData" name="左后" />
            </div>
          </div>
          <!-- center -->
          <div
            class="col-6 full-height row overflow-hidden justify-center items-center"
          >
            <GGChart
              style="z-index: 1"
              class="absolute-center"
              :seriesData="seriesData"
              :notifyData="notifyData"
              @reset="resetACC"
            />
            <Chassis
              :datas="tires"
              :notifyData="notifyData"
              @resetVLM="handleResetVLM"
            />
          </div>
          <!-- right -->
          <div class="col-3 full-height column q-pr-md q-pl-md">
            <div class="col-6 row justify-center items-center">
              <FrictionCircleChart :notifyData="notifyData" name="右前" />
            </div>
            <div class="col-6 row justify-center items-center">
              <FrictionCircleChart :notifyData="notifyData" name="右后" />
            </div>
          </div>
        </q-card-section>
      </q-card>
    </template>
  </Layout>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, reactive, ref } from "vue";
import Layout from "./components/Layout.vue";
import { NOTIFY } from "@/services/domainControl/ivse";
import { getDefaultSeriesData, transformSeriesData } from "./helper/ivse";

import { useDomainControlStore } from "@/stores/domainControl";
import { SERVICE } from "@/services/domainControl/define";
import useInitialize from "@/composables/domainControl/useInitialize";
import { useQuasar } from "quasar";
import GGChart from "./components/GGChart";
import FrictionCircleChart from "./components/FrictionCircleChart";
import Chassis from "./components/IVSE/Chassis.vue";
import { generateMockIVSENofifyData } from "@/services/domainControl/ivse";

const $q = useQuasar();

const domainControlStore = useDomainControlStore();
const seriesData = ref(getDefaultSeriesData());
const notifyData = reactive({} as DomianControl.IVSENotifyData);

const tires = ref([
  {
    name: "左前",
    value: 0,
    angle: 0,
  },
  {
    name: "右前",
    value: 0,
    angle: 0,
  },
  {
    name: "右后",
    value: 0,
    angle: 0,
  },
  {
    name: "左后",
    value: 0,
    angle: 0,
  },
]);

const handleNotify = (data: DomianControl.IVSENotifyData) => {
  // if (playStatus.value !== "play") return;
  data = transformSeriesData(data);
  parseData(data);
  parseSeriesData(data);
};
const parseData = (data: DomianControl.IVSENotifyData) => {
  Object.keys(data).forEach((key) => {
    notifyData[key] = data[key];
  });
  tires.value[0].value = data.UIRx_DUIdx_FL;
  tires.value[1].value = data.UIRx_DUIdx_FR;
  tires.value[2].value = data.UIRx_DUIdx_RR;
  tires.value[3].value = data.UIRx_DUIdx_RL;

  tires.value[0].angle = data.UIRx_AxleStAng_FA;
  tires.value[1].angle = data.UIRx_AxleStAng_FA;
  tires.value[2].angle = data.UIRx_AxleStAng_RA;
  tires.value[3].angle = data.UIRx_AxleStAng_RA;
};

const parseSeriesData = (data: DomianControl.IVSENotifyData) => {
  // data = transformSeriesData(data);
  const res = Object.keys(data).reduce((per, key) => {
    if (!["UIRx_ACULatAcc", "UIRx_ACULongdAcc"].includes(key)) return per;
    const value = data[key];
    const curList = seriesData.value[key];
    // TODO: 优化
    if (curList.length >= 100) curList.shift();
    curList.push(value);
    per[key] = curList;
    return per;
  }, {} as DomianControl.IVSESeriesData);
  seriesData.value = res;
};

const parseOutputValue = (value: DomianControl.OutputValue) => {
  // init reset DUR
  intoDUR();
};

useInitialize({
  handleNotify,
  SERVICE_UUID: SERVICE.uuid,
  NOTIFY_UUID: NOTIFY.uuid,
  parseOutputValue: parseOutputValue,
});
const intoDUR = () => {
  setTimeout(() => {
    domainControlStore.writeOutputValue({
      UITx_DURrst: 0,
    });
  });
};
const outOfDUR = () => {
  domainControlStore.writeOutputValue({
    UITx_DURrst: 1,
  });
};
// const handleReset = () => {
//   domainControlStore.writeOutputValue({
//     UITx_DURrst: 1,
//   });
//   setTimeout(() => {
//     domainControlStore.writeOutputValue({
//       UITx_DURrst: 0,
//     });
//   }, 500);
// };
const handleResetVLM = () => {
  domainControlStore.writeOutputValue({
    UITx_VLMReset: 1,
  });
  setTimeout(() => {
    domainControlStore.writeOutputValue({
      UITx_VLMReset: 0,
    });
  }, 500);
};

const resetACC = () => {
  seriesData.value.UIRx_ACULatAcc = [];
  seriesData.value.UIRx_ACULongdAcc = [];
};

onUnmounted(() => {
  // init reset DUR
  outOfDUR();
});

onMounted(() => {
  // setInterval(() => {
  //   handleNotify(generateMockIVSENofifyData());
  // }, 50);
});
</script>

<style scoped lang="scss">
.glowing-effect {
  position: relative;
  top: -15px;
  width: 70%;
  height: 10px; /* 根据需求调整高度 */
  margin: 0 auto;
}

.glowing-effect::before {
  content: "";
  display: block;
  position: absolute;
  top: 0px;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(
    ellipse at center,
    rgb(255, 255, 255) 0%,
    rgba(255, 255, 255, 0) 70%
  ); /* 中间亮，边缘透明 */
  // box-shadow: 0 0 10px white, 0 0 20px white, 0 0 40px white;
  animation: glow 2s ease-in-out infinite alternate;
}

@keyframes glow {
  from {
    opacity: 0.8;
  }
  to {
    opacity: 1;
  }
}

.FL {
  left: 150px;
  top: 10px;
}
.FR {
  top: 10px;
  right: 145px;
}
.RL {
  left: 150px;
  bottom: 10px;
}
.RR {
  right: 145px;
  bottom: 10px;
}
</style>
